import { formOptions } from '@tanstack/react-form'
import { z } from 'zod'

export const signupFormSchema = z.object({
  email: z.email({ message: 'Please enter a valid email address' }),
  username: z
    .string()
    .min(3, { message: 'Username must be at least 3 characters long' })
    .max(20, { message: 'Username must be less than 20 characters' }),
  password: z
    .string()
    .min(8, { message: 'Password must be at least 8 characters long' })
    .max(50, { message: 'Password must be less than 50 characters' }),
})

export const signupFormOpts = formOptions({
  defaultValues: {
    email: '',
    username: '',
    password: '',
  },
})

export const loginFormSchema = z.object({
  email: z.email({ message: 'Please enter a valid email address' }),
  password: z
    .string()
    .min(8, { message: 'Password must be at least 8 characters long' })
    .max(50, { message: 'Password must be less than 50 characters' }),
})

export const loginFormOpts = formOptions({
  defaultValues: {
    email: '',
    password: '',
  },
})
